module.exports = __webpack_public_path__ + "img/customer.c09553e2.png";